import React, { useState } from 'react'
import { FiMoreVertical } from 'react-icons/fi';
import styles from '../Bookings/CSEachBookings.module.css'
import CSBookingDetails from './CSBookingDetails';
import CSServices from './CSServices';
import { Link } from 'react-router-dom'

const CSEachBookings = props => {
    const { item } = props
    const [isListOpen, setIsListOpen] = useState(false)
    return (
        <Link to={item?.bookingDetails['currentStatus'] === "BOOKING_INITIATED" ? `/sessions/${item?.bookingDetails["bookingId"]}` : `/booking/` + item.bookingDetails["bookingId"]}
            className={styles.eachBookingWrapper}
        >
            <div className={styles.eachBookingContainer}>
                <CSBookingDetails item={item} />
                <div className={styles.moreWrapper}>
                    <FiMoreVertical />
                </div>
            </div>
            {isListOpen && <div>
                <CSServices item={item} />
            </div>}
        </Link>
    )
}

export default CSEachBookings